window.dataLayer = window.dataLayer || [];

let contentName = '';

const path = window.location.pathname;

if (path.includes("/cart")) {
  contentName = "Dein Warenkorb - Pure Encapsulations";
} else if (path.includes("/checkouts")) {
  contentName = "Checkout - Pure Encapsulations";
} else if (path.includes("/wishlist")) {
  contentName = "Merkliste - Pure Encapsulations";
}

window.dataLayer.push({
  event: "page_load",
  content_group: "Warenkorb & Checkout",
  content_name: contentName,
  content_id: "-",
  content_type: "Warenkorb & Checkout",
  asset_zone: "Europe",
  asset_country: "Germany",
  asset_brand: "Pure Encapsulations",
  asset_business: "NESTLÉ HEALTH SCIENCE",
  asset_digipi: "DIG0063518",
  user_id: " "
});
